module.exports = ".leaving-input {\n  outline: none;\n  resize: none;\n  width: 100%;\n  min-height: 100px; }\n\n.modal-body {\n  padding-top: 20px !important; }\n  .modal-body p {\n    font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss
// module id = ./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.scss
// module chunks = 0